import uuid from 'uuid';
function Treeutil({links,components,cache={}}) {
  this.links = links;
  this.components = components;
  this.cache = cache;
}
Treeutil.prototype.getFromAndToForComponent = function (component) {
  return this.getFromAndToForComponentId(component.id);
}
Treeutil.prototype.getFromAndToForComponentId = function (fromComponentId) {
  const fromComponents = this.components.filter( (c) => {
    const linksToHere = this.links.filter( ({target}) => {
      return target === c.id;
    });
    return linksToHere.filter( ({source}) => {
      return source === fromComponentId;
    }).length;
  }).map( (component) => {
    const linksFromHere = this.links.filter( ({source}) => {
      return source === component.id;
    });
    const linksToHere = this.links.filter( ({target}) => {
      return target === component.id;
    });
    const link = linksToHere[0];
    return {
      linksFromHere,
      linksToHere,
      link,
      component
    }
  });

  const linksToComponent = this.links.filter( ({target}) => {
    return target === fromComponentId;
  }).map( ({source}) => {
    return source;
  });
  const toComponents = this.components.filter( (c) => {
    return linksToComponent.includes(c.id);
  }).map( (component) => {
    const link = this.links.filter( ({source}) => {
      return source === component.id;
    })[0];
    return {
      component,
      link
    }
  });

  return {
    fromComponents,
    toComponents
  }
  
}

Treeutil.prototype.addLink = function ({name,...rest}, fromComponent, toComponent) {
  const linkData = {
    ...rest,
    id:uuid.v4(),
    source:fromComponent.id,
    target:toComponent.id,
    name
  }
  this.links.push(linkData);

  return linkData;
}

Treeutil.prototype.addComponent = function ({type,...rest}) {
  const component = {
    type,
    ...rest,
    id:uuid.v4(),
  }
  this.components.push(component);
  return component;
}

Treeutil.prototype.addComponentWithLinkData = function (component, linkData, newComponentData) {
  const addedComponents = [this.addComponent(newComponentData)];
  const addedLinks = [this.addLink(linkData, component, addedComponents[0])];
  return {
    addedComponents,
    addedLinks
  }
}

Treeutil.prototype.removeComponentsAndLinks = function (componentsToRemove, linksToRemove) {
  const componentIds = new Set(componentsToRemove.map( ({id}) => { return id; }));
  const linkIds = new Set(linksToRemove.map( ({id}) => { return id; }));

  const componentIdsToRemove = [];
  const linkIdsToRemove = [];


  for (let i = 0; i < this.components.length; i++) {
    const {id} = this.components[i];
    if (componentIds.has(id)) {
      componentIdsToRemove.push(i);
    }
  }

  for (let i = 0; i < this.links.length; i++) {
    const {id} = this.links[i];
    if (linkIds.has(id)) {
      linkIdsToRemove.push(i);
    }
  }
  const removedComponents = [];
  const removedLinks = [];

  for (let i = componentIdsToRemove.length - 1; i >= 0; i--) {
    const idToRemove = componentIdsToRemove[i];
    removedComponents.push(this.components[idToRemove]);
    this.components.splice(idToRemove, 1);
  }

  for (let i = linkIdsToRemove.length - 1; i >= 0; i--) {
    const idToRemove = linkIdsToRemove[i];
    removedLinks.push(this.links[idToRemove]);
    this.links.splice(idToRemove, 1);
  }
  return {
    removedComponents,
    removedLinks
  }
}

Treeutil.prototype.addComponentsAndLinks = function (componentsToAdd, linksToAdd) {
  componentsToAdd.forEach( (component) => {
    this.components.push(component);
  });
  linksToAdd.forEach( (link) => {
    this.links.push(link);
  });
  return {
    addedComponents: componentsToAdd,
    addedLinks: linksToAdd
  }
}

Treeutil.prototype.findComponentById = function (in_id) {
  return this.components.filter( ({id}) => {
    return id === in_id;
  })[0];
}

Treeutil.prototype.removeComponent = function (component) {
  const componentsToRemove = [component];
  const linksToRemove = this.links.filter( ({source,target}) => {
    return source === component.id || target === component.id;
  });

  return this.removeComponentsAndLinks(
    componentsToRemove,
    linksToRemove
  );

}

Treeutil.prototype.removeUnlinkedComponents = function (id) {
}

export default Treeutil;
